import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";
import Highlighter from "react-highlight-words";
import React, { useState } from "react";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useDispatch } from "react-redux";
import FilterDropDown from "../../../../../ReusableComponents/FilterDropDown/FilterDropDown";
import LicenceTypePopUp from "../DrivingLicenceApply/UpdateLicTypePopUp";
import { setAppError } from "../../../../../store/userSlice";
import { useEffect } from "react";
import RemovePopUp_Driving from "./Renew";

export default function ListLicenceRenew({
  token,
  titles = [],
  list = [],
  updateData,
  searchWords,
  setSearchWords,
}) {
  const [checkedItems, setCheckedItems] = useState({});

  //filter
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectVisaProvider, setSelectVisaProvider] = useState("");
  const [filter, setFiltered] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    setFiltered(list);
  }, [list]);

  const [datalist, SetListData] = useState([]);
  const [Popup, setPopUp] = useState(false);

  const handleCheckboxChange = (event, employee_id, list) => {
    const isChecked = event.target.checked;
    setCheckedItems((prevState) => {
      const nextState = { ...prevState };
      if (isChecked) {
        nextState[employee_id] = true; // Set the checkbox state to true
      } else {
        delete nextState[employee_id]; // Remove the entry for unchecked checkboxes
      }
      return nextState;
    });
    SetListData((prevItemList) => {
      const updatedList = prevItemList.filter((item) => item !== list);
      if (isChecked) {
        updatedList.push(list);
      }
      return updatedList;
    });
  };

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(filter || []);

  const onChangeValue = (e) => {
    const clientStatus = e.target.value;
    setSelectedStatus(clientStatus);
  };

  const visaProviderFilter = (e) => {
    const visaProvider = e.target.value;
    console.log("Selected Visa Provider:", visaProvider);
    setSelectVisaProvider(visaProvider);
  };

  const popOpen = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      setPopUp(true);
    }
  };

  const callApi = () => {
    setCheckedItems({});
    updateData();
  };
  const [open, setOpen] = useState(false);
  const handleOpenClick = () => {
    var list = Object.entries(checkedItems)
      .filter(([emp_id, isChecked]) => isChecked)
      .map(([emp_id]) => emp_id);
    console.log(checkedItems.length);
    if (list.length === 0) {
      dispatch(
        setAppError({
          msg: "Please select Check box",
        })
      );
    } else {
      setOpen(true);
    }
  };
  return (
    <>
      <div className="flex-wrap  gap-2 w-full items-center flex flex-row-reverse">
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => {
            handleOpenClick();
          }}
        >
          <p>Remove</p>
        </button>
        <button
          className="p-2 px-4 rounded-md bg-blue disabled:bg-gray text-white min-w-fit text-sm flex items-center gap-2"
          onClick={() => popOpen()}
        >
          <p>Renew</p>
        </button>
        <Search
          searchKey={["employee_id", "visa_reference_number", "border_number"]}
          setSearchWords={setSearchWords}
        />
        {!list ? (
          <></>
        ) : (
          <>
            <FilterDropDown
              onChange={visaProviderFilter}
              title={"Visa Provider"}
              url={`/sadaad/visa-providers/`}
              token={token}
              selectedStatus={selectVisaProvider}
            />
            <FilterDropDown
              onChange={onChangeValue}
              title={"Client"}
              url={`/sadaad/clients`}
              token={token}
              selectedStatus={selectedStatus}
            />
          </>
        )}
      </div>
      <p className="text-sm w-full text-right font-medium mb-1">{`Slide / scroll to right >`}</p>

      <CountPerPage />
      <div className="relative bg-white">
        <div className="overflow-x-auto max-h-[70vh] ">
          <div className="sticky top-0 z-10 bg-white min-w-[3440px]">
            <div className="grid grid-cols-table-21 gap-5 p-6 text-center">
              {titles.map((t, index) => (
                <p key={index} className="font-semibold uppercase">
                  {t}
                </p>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-table-21 gap-5 p-6 bg-white text-center">
            {list?.isLoading && <LoadingWithLable className="col-span-full" />}
            {!list?.isLoading && <NoDataFound />}
            {!list?.isLoading &&
              currentList
                .filter((data) => {
                  if (selectVisaProvider !== "") {
                    return data.visa_provider === selectVisaProvider;
                  }
                  if (selectedStatus !== "") {
                    return data.client_name === selectedStatus;
                  }
                  return true; // If no filters are applied, return all data.
                })
                .map((list, index) => (
                  <React.Fragment key={index}>
                    <PaginationIndex index={index} />
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.employee_id || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.name || "-"}
                      />
                    </p>

                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.actual_profession || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_profession || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.visa_provider || "-"}
                      />
                    </p>
                    <p className="overflow-x-hidden">
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.sponsor || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.client_name || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.iqama_number || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.license_type || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.apply_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.issue_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.expiry_date || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.valid_days || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.admission_fee || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.medical_fee || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.govt_fee || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.inducement_fee || "-"}
                      />
                    </p>
                    <p>
                      <Highlighter
                        searchWords={searchWords}
                        autoEscape={true}
                        textToHighlight={list.driving_status || "-"}
                      />
                    </p>
                    {selectedStatus === list.client_name &&
                    selectVisaProvider === list.visa_provider ? (
                      <div>
                        <input
                          key={list.employee_id} // Use a unique identifier as the key
                          type="checkbox"
                          checked={checkedItems[list.employee_id] || false}
                          onChange={(event) =>
                            handleCheckboxChange(event, list.employee_id, list)
                          }
                        />
                      </div>
                    ) : (
                      ""
                    )}

                    <hr
                      className={`border-[1.5px] border-slate-100  w-full col-span-full `}
                    />
                  </React.Fragment>
                ))}
          </div>
        </div>
      </div>
      <Pagination />

      {Popup ? (
        <LicenceTypePopUp
          token={token}
          list={datalist}
          PopUp={Popup}
          setPopUp={setPopUp}
          url={"/drivingLicense/updateLicenseType"}
          callBack={callApi}
          flage={false}
        />
      ) : (
        ""
      )}
      {open ? (
        <RemovePopUp_Driving
          open={open}
          setOpen={setOpen}
          list={datalist}
          callBack={callApi}
        />
      ) : (
        ""
      )}
    </>
  );
}
